/**
 * Created by hernanherreros on 2019-04-30
 */

import * as React from 'react'
import styled from 'styled-components'
import { Spin } from 'antd'

export default class LoadingScreen extends React.Component {
  render() {
    return (
      <Container>
        <Spin size="large"/>
      </Container>
    )
  }
}

const Container = styled.div`
  height: 100vh;
  width: 100vw;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
`
